"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Avatar = _interopRequireDefault(require("../../Clients/Avatar"));
var _Button = _interopRequireDefault(require("../../../Button"));
var _TicketStatus = require("../TicketStatus");
var _TicketType = require("../TicketType");
var _constants = require("../../../../constants");
var _communication = require("../../../../icons-react/communication");
var _excluded = ["avatarUrl", "type", "value"];
var TicketLogIconButton = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var className = _ref.className,
    avatarUrl = _ref.avatarUrl,
    type = _ref.type,
    value = _ref.value,
    onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(StyledIconButton, {
    className: className,
    functional: true,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(StyledIcon, {
    avatarUrl: avatarUrl,
    type: type,
    value: value
  }));
});
var StyledIconButton = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "TicketLogIconButton__StyledIconButton",
  componentId: "sc-155m5b7-0"
})(["width:16px;height:16px;min-height:16px;"]);
var StyledBox = _styledComponents["default"].div.withConfig({
  displayName: "TicketLogIconButton__StyledBox",
  componentId: "sc-155m5b7-1"
})(["border-radius:100%;box-sizing:border-box;margin:0 auto;"]);
var StyledIconType = (0, _styledComponents["default"])(StyledBox).withConfig({
  displayName: "TicketLogIconButton__StyledIconType",
  componentId: "sc-155m5b7-2"
})(["height:16px;width:16px;", " ", " ", " ", " ", ""], function (_ref2) {
  var type = _ref2.type;
  return type === _TicketType.TYPES.UPDATING && 'background-image: linear-gradient(90deg, #35DAD8 0.46%, #1B58E2 100%);';
}, function (_ref3) {
  var type = _ref3.type;
  return type === _TicketType.TYPES.TOUR_SELECTION && "background-image: linear-gradient(270deg, #DD3D3D 0%, #A521AB 100%);";
}, function (_ref4) {
  var type = _ref4.type;
  return type === _TicketType.TYPES.COMMON_QUESTION && "background-image: linear-gradient(270deg, #008BCF 26.24%, #9E4DE3 100%);";
}, function (_ref5) {
  var type = _ref5.type;
  return type === _constants.TICKET_LOG_TYPES.HOTLINE && "background-image: linear-gradient(270deg, #FBF7E7 0%, #F7E5E5 61.33%);";
}, function (_ref6) {
  var type = _ref6.type;
  return type === _TicketType.TYPES.UNKNOWN && "background-color: #C2C5CC;";
});
var StyledIconStatus = (0, _styledComponents["default"])(StyledBox).withConfig({
  displayName: "TicketLogIconButton__StyledIconStatus",
  componentId: "sc-155m5b7-3"
})(["height:6px;width:6px;", " ", " ", " ", " ", " ", ""], function (_ref7) {
  var status = _ref7.status;
  return status === _TicketStatus.STATUSES.OPEN && "border: 1px solid #FFB266;";
}, function (_ref8) {
  var status = _ref8.status;
  return status === _TicketStatus.STATUSES.WAIT_FOR_OPERATOR && "background-color: #EDBD25;";
}, function (_ref9) {
  var status = _ref9.status;
  return status === _TicketStatus.STATUSES.WAIT_FOR_CLIENT && "background-color: #EDBD25;";
}, function (_ref10) {
  var status = _ref10.status;
  return status === _TicketStatus.STATUSES.WAIT_FOR_SERVICE && "background-color: #D0021B;";
}, function (_ref11) {
  var status = _ref11.status;
  return status === _TicketStatus.STATUSES.CLOSED && "background-color: #919499;";
}, function (_ref12) {
  var status = _ref12.status;
  return status === _TicketStatus.STATUSES.PLANNED && "border: 1px solid #d0021b;";
});
var StyledAvatar = (0, _styledComponents["default"])(_Avatar["default"]).withConfig({
  displayName: "TicketLogIconButton__StyledAvatar",
  componentId: "sc-155m5b7-4"
})(["width:100%;height:100%;"]);
var StyledIcon = (0, _styledComponents["default"])(function (_ref13) {
  var avatarUrl = _ref13.avatarUrl,
    type = _ref13.type,
    value = _ref13.value,
    props = (0, _objectWithoutProperties2["default"])(_ref13, _excluded);
  var Icon = _react["default"].Fragment;
  switch (type) {
    case _constants.TICKET_LOG_TYPES.TASK:
    case _constants.TICKET_LOG_TYPES.NOTE:
      Icon = /*#__PURE__*/_react["default"].createElement(StyledAvatar, {
        url: avatarUrl
      });
      break;
    case _constants.TICKET_LOG_TYPES.TYPE:
      Icon = /*#__PURE__*/_react["default"].createElement(StyledIconType, {
        type: value
      });
      break;
    case _constants.TICKET_LOG_TYPES.STATUS:
      Icon = /*#__PURE__*/_react["default"].createElement(StyledIconStatus, {
        status: value
      });
      break;
    case _constants.TICKET_LOG_TYPES.GROUP:
      Icon = /*#__PURE__*/_react["default"].createElement(_communication.Group, null);
      break;
    case _constants.TICKET_LOG_TYPES.CREATE:
    case _constants.TICKET_LOG_TYPES.MANAGER:
      Icon = /*#__PURE__*/_react["default"].createElement(_communication.Bot, null);
      break;
    default:
      Icon = /*#__PURE__*/_react["default"].createElement(_communication.Bot, null);
      break;
  }
  return /*#__PURE__*/_react["default"].cloneElement(Icon, props);
}).withConfig({
  displayName: "TicketLogIconButton__StyledIcon",
  componentId: "sc-155m5b7-5"
})([""]);
TicketLogIconButton.displayName = 'TicketLogIconButton';
TicketLogIconButton.propTypes = {
  className: _propTypes["default"].string,
  avatarUrl: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  value: _propTypes["default"].string,
  type: _propTypes["default"].oneOf(Object.values(_constants.TICKET_LOG_TYPES)).isRequired
};
TicketLogIconButton.defaultProps = {
  className: '',
  avatarUrl: null,
  onClick: Function.prototype,
  value: null
};
var _default = exports["default"] = TicketLogIconButton;